import {
    UPDATE_CART,
    GET_PRODUCT_LIST,
    ADD_PRODUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
    CLEAR_ALL_PRODUCT,
    SETTLE
} from "./mutation-type.js";

function objectToQueryString(obj) {
return Object.keys(obj).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
}

const name = "cart";

const state = {
    dataList: [] // 购物车列表数据
};

const getters = {
    cartCount(state) {
        let count = 0;
        state.dataList.forEach(data => {
            count = count + data.ProductList.length;
        });
        return count;
    }
};

const actions = {
    async [GET_PRODUCT_LIST]({ commit },channel) {
        let url = `api/ShoppingCart/GetProductList?channel=${channel}`;
        let res = await rt.get(url);
        let dataList = res.map(item => {
            item.currentIndex = -1;
            item.ProductList.forEach(product => {
                product.checked = false;
            });
            return item;
        });
        commit(UPDATE_CART, dataList);
    },
    async [ADD_PRODUCT]({ dispatch }, data) {
        let url = `api/ShoppingCart/AddProduct`;
        await rt.post(url,data);

        // dispatch(GET_PRODUCT_LIST,data.channel);
    },
    async [UPDATE_PRODUCT]() {},
    async [DELETE_PRODUCT]({ dispatch }, data) {
        let url = `api/ShoppingCart/DeleteProduct`;
        await rt.post(url,data.ids);

        dispatch(GET_PRODUCT_LIST,data.channel);
    },
    async [CLEAR_ALL_PRODUCT]({ dispatch }, channel) {
        let url = `api/ShoppingCart/ClearAllProduct?channel=${channel}`;
        await rt.post(url);

        // dispatch(GET_PRODUCT_LIST,channel);
    },
    async [SETTLE]({ dispatch }, data) {
        let url = "api/ShoppingCart/Settle";
        var id = await rt.post(url, data);

        dispatch(GET_PRODUCT_LIST,data.channel);

        return id;
    }
};

const mutations = {
    [UPDATE_CART](state, dataList) {
        state.dataList = dataList;
    }
};

export default {
    name,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/cart/index.js